import { IRootState } from "../../../state";
import { IUserState } from "../../../state/user";
import { useSelector } from "react-redux";

export const useUserStore = () => {
  const { token, user, userStatus, createProfile, tokenNew, inviteLink, referralCode } =
    useSelector((state: IRootState) => state.user as IUserState);

  const profileUser = user ?? tokenNew?.user ?? null;
  const hasPhone = Boolean(profileUser?.phone || profileUser?.fireBasePhone);
  const isProfileComplete = Boolean(profileUser?.contact_id) && hasPhone;

  return {
    token,
    tokenNew,
    user,
    userStatus,
    createProfile,
    inviteLink,
    referralCode,
    profileUser,
    hasPhone,
    isProfileComplete,
  };
};

